import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export type NotionProductUpdateProperties = {
  update_title: string;
  customer_facing_description: string;
  engineer_description: string;
  quarter: string;
  external_or_internal: string;
  link: string;
  help_center_link: string;
  category: string[];
};

export type NotionProductUpdate = {
  id: string;
  created_time?: string;
  last_edited_time?: string;
  url?: string;
  archived?: boolean;
  properties: NotionProductUpdateProperties;
};

export const getProductUpdates = async ({
  token,
}: APIRequest): APIResponsePromise<{ items: NotionProductUpdate[] }> =>
  await _callBackend('/notion/product_updates', 'GET', null, token);
